<section app-home-carousel></section>
<section app-home-welcome></section>
<section app-home-style></section>
<section
  app-home-welcome
  [texts]="['MODERN STYLE','SOFT CONFIDENCE','YOUNG ENERGY','EASY TO WEAR']"
  [right]="true"
></section>

<section app-home-categoies></section>
<section app-home-why></section>

<!-- <section app-home-new-arrivals></section>
<section app-home-best-sellers></section>
<section app-home-products-banner></section> -->
